import Base from '../../../../packages/jgile/laravel-vue/resources/js/models/BaseModel';

export default class Asset extends Base {
    resource() {
        return 'assets';
    }

    get isBundle() {
        return this.asset_type !== 'simple';
    }

    get isSimple() {
        return this.asset_type === 'simple';
    }
}
